import { Step, StepLabel, Stepper } from '@mui/material';
import { getWccStatusesArrayByInvoiceType, INVOICE_TYPE_CLIENT, InvoiceType, WccStatus } from '@sr/dto';

export const WccStatusStepper = ({ status, invoiceType = INVOICE_TYPE_CLIENT }: { status: WccStatus, invoiceType?: InvoiceType  }) => {

  
  const steps = getWccStatusesArrayByInvoiceType(invoiceType);
  return (<Stepper activeStep={steps.findIndex((step)=>step.id === status)}>
    {steps.map((status) => (
      <Step key={status.id}>
        <StepLabel>{status.label}</StepLabel>
      </Step>
    ))}
  </Stepper>);
};
